export const YYYY_DATE_FORMAT = 'YYYY';
export const MM_YYYY_DATE_FORMAT = 'MM/YYYY';
export const DEFAULT_DD_PREFIX = '01/';
